// @ts-nocheck
import React from 'react';
import PropTypes from 'react-proptypes';
import { Form } from '@fulcrumapp/fulcrum-core';
import Dialog from '../shared/dialog';

export default class ReportTemplatePicker extends React.Component {
  static propTypes = {
    show: PropTypes.bool.isRequired,
    form: PropTypes.instanceOf(Form),
    onCancel: PropTypes.func.isRequired,
    onDone: PropTypes.func.isRequired,
  };

  render() {
    const { styles } = ReportTemplatePicker;

    return (
      <Dialog
        show={this.props.show}
        title="Select Report Template"
        positive={null}
        width={400}
        bodyclassName={styles.body}
        onNegativeClick={this.handleNegativeClick}
      >
        <div className={styles.container}>
          {this.renderTemplates()}
        </div>
      </Dialog>
    );
  }

  renderTemplates() {
    if (!this.props.show) {
      return null;
    }

    const { styles } = ReportTemplatePicker;

    return this.props.form.reportTemplates.map((template, index) => {
      const handler = () => this.handleTemplateClick(template);

      return (
        <a
          key={index}
          href="#"
          className={styles.template}
          onClick={handler}
        >
          {template.name}
          <div className={styles.description}>{template.description}</div>
        </a>
      );
    });
  }

  handleTemplateClick = (template) => {
    this.props.onDone(template);
  };

  handleNegativeClick = () => {
    this.props.onCancel();
  };
}

const styles = cssInJS({
  container: {
    maxHeight: 500,
  },

  body: {
  },

  template: {
    display: 'block',
    padding: 8,
    color: '#01a6ff',
    textDecoration: 'none',
    borderRadius: 3,
    cursor: 'pointer',
    marginLeft: -8,

    ':hover': {
      color: '#008fdc',
      backgroundColor: '#f1f1f1',
    },
  },

  description: {
    color: '#777',
    fontSize: 12,
    paddingTop: 3,
  },
});

ReportTemplatePicker.styles = styles;
